import { render, staticRenderFns } from "./_0.vue?vue&type=template&id=38cde6a1&scoped=true&"
import script from "./_0.vue?vue&type=script&lang=js&"
export * from "./_0.vue?vue&type=script&lang=js&"
import style0 from "./_0.vue?vue&type=style&index=0&id=38cde6a1&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38cde6a1",
  null
  
)

export default component.exports